import React from 'react'
import { Form, Label } from 'semantic-ui-react'

const SelectInput = ({ input, values, meta: { touched, error } }) => {
    return (
        <Form.Field error={touched && !!error}>
            <select {...input} >
                {
                    values &&
                    values.map((v, index) =>
                        <option key={index} value={v.value}>{v.text}</option>)
                }
                {/* <option value="">Tipo de Documento</option>
                <option value="1">D.N.I</option>
                <option value="2">Carnet de Extranjería</option> */}
            </select>
            {touched && error && (<Label basic color='red'>{error}</Label>)}
        </Form.Field>
    )
}

export default SelectInput
